<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '../stores'

const router = useRouter()
const user = useUserStore()

const isLoggedIn = computed(() => !!user.token)

function goLogin() {
  router.push('/login')
}

function logout() {
  user.clearSession()
  router.push('/')
}
</script>

<template>
  <header class="app-header">
    <div class="header-inner">
      <router-link to="/" class="brand">
        <span class="brand-icon">👾</span>
        <span class="display-font brand-text">Retro Arcade</span>
      </router-link>
      <nav class="nav">
        <router-link to="/games" class="nav-link">
          <span class="nav-emoji">🎮</span>
          <span class="nav-text">全部游戏</span>
        </router-link>
        <router-link to="/ranks" class="nav-link">
          <span class="nav-emoji">🏆</span>
          <span class="nav-text">排行榜</span>
        </router-link>
        <router-link to="/about" class="nav-link">
          <span class="nav-emoji">ℹ️</span>
          <span class="nav-text">关于</span>
        </router-link>
      </nav>
      <div class="user-slot">
        <template v-if="isLoggedIn">
          <router-link to="/me" class="nav-link">
            <span class="nav-emoji">👤</span>
            <span class="nav-text">{{ user.user?.username }}</span>
          </router-link>
          <button class="pixel-btn pixel-btn--ghost pixel-btn--sm" @click="logout">退出</button>
        </template>
        <template v-else>
          <button class="pixel-btn" @click="goLogin">登录 / 注册</button>
        </template>
      </div>
    </div>
  </header>
</template>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(15, 15, 30, 0.85);
  backdrop-filter: blur(8px);
  border-bottom: 2px solid var(--ra-neon-pink);
  box-shadow: 0 2px 12px rgba(255, 46, 136, 0.25);
}

.header-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ra-fg-strong);
  font-size: 20px;
  text-shadow: 0 0 10px rgba(255, 46, 136, 0.8);
}
.brand:hover {
  color: var(--ra-neon-pink);
}
.brand-icon {
  font-size: 26px;
  animation: float 2.4s ease-in-out infinite;
}
.brand-text {
  letter-spacing: 1px;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

.nav {
  display: flex;
  gap: 20px;
}
.nav-link {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--ra-fg);
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 4px;
  transition: background 0.15s, color 0.15s;
}
.nav-link:hover {
  color: var(--ra-neon-cyan);
  background: rgba(0, 240, 255, 0.05);
}
.nav-link.router-link-active {
  color: var(--ra-neon-pink);
  text-shadow: var(--ra-shadow-neon-pink);
}
.nav-emoji {
  font-size: 16px;
}

.user-slot {
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 640px) {
  .nav-text { display: none; }
  .brand-text { display: none; }
  .header-inner { height: 56px; }
}
</style>

<style>
/* pixel-btn 抽取到全局也可,先局部用 */
.pixel-btn {
  font-family: var(--ra-font-pixel);
  font-size: 10px;
  letter-spacing: 1px;
  background: var(--ra-neon-pink);
  color: #0f0f1e;
  border: none;
  padding: 8px 14px;
  box-shadow: 0 4px 0 #a01e5c, 0 0 12px rgba(255, 46, 136, 0.6);
  transition: transform 0.08s, box-shadow 0.08s;
}
.pixel-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 0 #a01e5c, 0 0 18px rgba(255, 46, 136, 0.9);
}
.pixel-btn:active {
  transform: translateY(3px);
  box-shadow: 0 1px 0 #a01e5c;
}
.pixel-btn--ghost {
  background: transparent;
  color: var(--ra-neon-cyan);
  box-shadow: inset 0 0 0 2px var(--ra-neon-cyan);
}
.pixel-btn--ghost:hover {
  box-shadow: inset 0 0 0 2px var(--ra-neon-cyan), 0 0 12px rgba(0, 240, 255, 0.6);
}
.pixel-btn--sm {
  font-size: 9px;
  padding: 5px 10px;
}
</style>
